<template>
  <div class="grid grid-cols-5 space-x-2 mb-1">
    <div class="col-span-5 flex flex-row items-center">
      Display Only:
    </div>
    <div class="col-span-4 flex flex-row items-center">
      <textarea class="h-24 w-full"
        placeholder="{}"
        disabled
        v-model="displayFormValuesStringified"
        @change="markPendingItem()"
      />
      <span class="p-2"
        v-show="pendingChanges">
        *
      </span>
      <div class="p-2 text-red-400"
        v-if="jsonError">
        Error in JSON parse
      </div>
    </div>
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <div class="grow"></div>
      <button class="bg-orange-200 p-1 justify-center"
        @click="resetChanges">
        Reset
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    defaultValue: Object,
    value: undefined,
  },
  components: {},
  data() {
    return {
      displayFormValues: undefined,

      formValues: {
        current: undefined,
        input: undefined,
      },

      jsonError: false,

      pendingChanges: false,
    }
  },
  methods: {
    resetChanges() {
      this.formValues.current = this.formValues.input
      this.pendingChanges = false
    },
    updateValue() {
      this.$emit('input', JSON.parse(this.formValues.input))
    },
    markPendingItem() {
      this.pendingChanges = true
      this.$emit('markPending')
    },
  },
  computed: {
    displayFormValuesStringified() {
      return JSON.stringify(this.displayFormValues, (key, val) => val, 2)
    },
  },
  mounted() {
    this.displayFormValues = this.value

    this.formValues.current = JSON.stringify(this.defaultValue, (key, val) => val, 2)
    this.formValues.input = JSON.stringify(this.defaultValue, (key, val) => val, 2)
  },
  watch: {
    value(newValue) {
      // this.formValues.input = JSON.stringify(newValue)
      this.displayFormValues = newValue
    },
    'formValues.input'(newValue) {
      if (newValue.length > 0) {
        try {
          JSON.parse(newValue)
          this.jsonError = false
        }
        catch {
          this.jsonError = true
        }
      }
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues.current = JSON.stringify(newValue, (key, val) => val, 2)
      this.formValues.input = JSON.stringify(newValue, (key, val) => val, 2)
    },
  }
}
</script>
